import { render } from "./homeEditOffice.vue?vue&type=template&id=08743f31&scoped=true"
import script from "./homeEditOffice.vue?vue&type=script&lang=js"
export * from "./homeEditOffice.vue?vue&type=script&lang=js"

import "./homeEditOffice.vue?vue&type=style&index=0&id=08743f31&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08743f31"]])

export default __exports__